export default {
	en: {
		rumah: 'House',
		apartemen: 'Apartment',
		kantor: 'Office',
		ruko: 'Shop',
		yes: 'Yes',
		no: 'No',
		approved: 'Approved',
		denied: 'Denied',
		'social media': 'Social Media',
		agent: 'Agent',
		friend: 'Friend',
		other: 'Other',
		'unqualified bi checking': 'Unqualified BI Checking',
		'inadequate down-payment': 'Inadequate down-payment',
		'contract worker': 'Contract Worker',
		'self-employment': 'Self-Employment',
		employee: 'Employee',
		unemployed: 'Unemployed',
		'as soon as possible': 'As soon as possible',
		carport: 'Carport',
		garage: 'Garage',
		'garage and carport': 'Garage and Carport',
		anything: 'Anything',
		government: 'Government',
		company: 'Company'
	},
	id: {
		rumah: 'Rumah',
		apartemen: 'Apartemen',
		kantor: 'Kantor',
		ruko: 'Ruko',
		yes: 'Ya',
		no: 'Tidak',
		approved: 'Diterima',
		denied: 'Ditolak',
		'social media': 'Media Sosial',
		agent: 'Agen',
		friend: 'Teman',
		other: 'Lainnya',
		'unqualified bi checking': 'Terkendala BI Checking',
		'inadequate down-payment': 'Down-payment tidak cukup',
		'contract worker': 'Pekerja Kontrak',
		'self-employment': 'Wiraswasta',
		employee: 'Karyawan',
		unemployed: 'Sedang tidak bekerja',
		'as soon as possible': 'Secepatnya',
		carport: 'Carport',
		garage: 'Garasi',
		'garage and carport': 'Garasi dan Carport',
		anything: 'Apa saja',
		government: 'PNS',
		company: 'Pekerja Swasta'
	}
};
